<template>
	<div>
	    <p class="simple-error" id="highslippage-warning" v-if="showSlippage && slippage === 'error'">
	    	<span class='text'>
              Warning! Slippage calculation failed: since the app isn’t able to warn you of a possibly high slippage, if you do go further, please manually confirm that the amount you'll be withdrawing (displayed in the fields above) is what you'd expect given your total balance in that pool.
            </span>
	    </p>

        <div v-if="isPriceImpactNotSlippage">
            <p class="info-message" id="slippage-warning" v-if="showSlippage">
                <span v-if="typeof priceOracle !== 'undefined' && priceOracle.length === 1">Current pool rate: 1 {{pool.coins[1].symbol}} = {{truncWithXSignificantDecimals(priceOracle[0], 4)}} {{pool.coins[0].symbol}}<br /></span>
                <span v-if="slippage <= 0 && slippage < limit">HIGH PRICE IMPACT:</span>
                <span v-if="slippage <= 0 && slippage >= limit">Price impact:</span>
                <span class="percent" v-if="slippage <= 0"> {{truncWithXSignificantDecimals(Math.abs(slippage)*100, 2)}}%</span>
    	    </p>
        </div>
        <div v-else>
            <p class='simple-error' id='highslippage-warning' v-if='showSlippage && slippage < limit'>
    	    	<span class='text'>
              Warning! High slippage(incl. pricing):
            <span class='percent'>{{truncWithXSignificantDecimals(-slippage*100, 2)}}</span>%
              <span class='tooltip'>[?]
                <span class='tooltiptext long'>
                  Slippage comes from depositing too many coins not in balance, and current coin prices are additionally accounted for
                </span>
              </span>
            </span>
    	    </p>

    	    <p class='info-message' id='slippage-warning' v-if='showSlippage && slippage <= 0 && slippage >= limit'>
    	    	<span class='text'>
              Slippage(incl. pricing):
            </span>
            <span class='percent'>{{truncWithXSignificantDecimals(-slippage*100, 2)}}</span>%
              <span class='tooltip'>[?]
                <span class='tooltiptext long'>
                  Slippage comes from depositing too many coins not in balance, and current coin prices are additionally accounted for
                </span>
              </span>
    	    </p>
    	    <p class='success' id='bonus-window' v-if='showSlippage && slippage > 0'>
    	    	Bonus(incl. pricing): <span>{{truncWithXSignificantDecimals(slippage*100, 2)}}</span>%
            <span class='tooltip'>[?]
              <span class='tooltiptext long'>
                Bonus comes as an advantage from current coin prices which usually appears for coins which are {{ $route.name == 'Deposit' ? 'low' : 'high'}} in balance
              </span>
            </span>
    	    </p>
        </div>

      <p class='simple-error' id='nobalance-warning' v-if='show_nobalance'>
      	Warning! Not enough balance for {{noBalanceText}} token in the contract
      </p>
      <p class='info-message gentle-message' id='susd-warning' v-if="currentPool == 'susdv2' && showSlippage && slippage < -0.01">
        Please add coins in a balanced proportion
      </p>
	</div>
</template>

<script>
    import { getters, contract as currentContract } from '../../contract'
    import pools from '@/constants/pools'
    import { truncWithXSignificantDecimals } from '../../utils/Number'

    export default {
    	props: [
            'show_nobalance',
            'show_nobalance_i',
            'isDeposit',
            'priceOracle',
        ],
        methods: {
            truncWithXSignificantDecimals,
        },
        computed: {
          ...getters,
          limit() {
              return this.pool.cryptoPool ? -0.03 : -0.005
          },
          /**
            On the Swap page, internal logic already differentiates `slippage` and `cryptoTradeSlippage`,
            and displays the proper calculations and copy.
            On the Deposit page, the logic for this differentiation resides in this component (Slippage):
            here we differentiate regular pools, where slippage is actual slippage, and crypto pools,
            where the `slippage` variable contains the price impact, not slippage. This computed prop
            allows us to display the relevant copy for either slippage or price impact.
          */
          pool() {
              return pools.getById(this.currentPool);
          },
          isPriceImpactNotSlippage() {
              return (
                  (this.pool.cryptoPool || this.pool.isStablePoolWithSpecialUnpeggedAssets) &&
                  this.isDeposit
              );
          },
          noBalanceText() {
          	if(!this.show_nobalance) return '';

						//there is an issue where this prop doesn't receive the token/pool name
          	let kv = Object.entries(this.all_currencies)[this.show_nobalance_i];
            if (
                !(this.show_nobalance_i == 2 && this.currentPool == 'usdt') &&
                !this.pool.containsCompoundCoin &&
                !this.pool.containsYearnBasedCoin
            ) {
							if (Array.isArray(kv)) {
								return kv[1] + " (in " + kv[0] + ")";
                            }
						}
						if (Array.isArray(kv))
            	return kv[1];
						else
							return 'this';
          },
        },
    }
</script>
